var map = {
	"./decidim/avatar-multiuser.png": 96061,
	"./decidim/brands/facebook.svg": 20982,
	"./decidim/brands/google.svg": 9312,
	"./decidim/brands/twitter-x.svg": 53461,
	"./decidim/cc-badge.png": 44939,
	"./decidim/decidim-logo.svg": 94591,
	"./decidim/default-avatar.svg": 33491,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 65785,
	"./decidim/icons.svg": 95842,
	"./decidim/pattern.png": 93249,
	"./decidim/placeholder-card-g.svg": 38414,
	"./decidim/placeholder-card-l.svg": 88037,
	"./decidim/placeholder.jpg": 40244,
	"./decidim/remixicon.symbol.svg": 78742,
	"./decidim/vendor/social-share-button/douban.svg": 14073,
	"./decidim/vendor/social-share-button/email.svg": 93754,
	"./decidim/vendor/social-share-button/facebook.svg": 94834,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 69726,
	"./decidim/vendor/social-share-button/hacker_news.svg": 55386,
	"./decidim/vendor/social-share-button/linkedin.svg": 28232,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 42785,
	"./decidim/vendor/social-share-button/pinterest.svg": 11332,
	"./decidim/vendor/social-share-button/reddit.svg": 446,
	"./decidim/vendor/social-share-button/telegram.svg": 46047,
	"./decidim/vendor/social-share-button/tumblr.svg": 95804,
	"./decidim/vendor/social-share-button/twitter.svg": 76719,
	"./decidim/vendor/social-share-button/vkontakte.svg": 78957,
	"./decidim/vendor/social-share-button/wechat.svg": 90512,
	"./decidim/vendor/social-share-button/whatsapp.svg": 81424,
	"./decidim/vendor/social-share-button/x.svg": 53210,
	"./decidim/vendor/social-share-button/xing.svg": 53198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38320;